import React from 'react';
import PaymentFormClaroSocioContainer from '../containers/PaymentFormClaroSocioContainer'
import { Page } from 'react-onsenui';
import { GenericFormContextProvider } from '../../context/genericFormContext';
import * as sdkclaro from '@claropay/claro-pay-sdk-v2'

const PaymentServicePage = ({ match, location }) => {

    const { 
        state: { 
            sdkVersion, 
            paymentsConfig, 
            isClaroPartner,
            serviceConfigIndex
        }
    } = location;
    sdkclaro.getInstance().switchGoBackButton(true)
    return (
        <Page id="payment-service">
            <GenericFormContextProvider>
                <PaymentFormClaroSocioContainer 
                    serviceConfigIndex={serviceConfigIndex} 
                    sdkVersion = {sdkVersion}
                    paymentsConfig = {paymentsConfig} 
                    isClaroPartner = {isClaroPartner}
                />
            </GenericFormContextProvider>
        </Page>    
  );
};


export default PaymentServicePage